export const useQrStore = defineStore(
	"qrStore",
	() => {
		const qrCode = ref("")
		const color = ref("")
		const lane = ref("")

		const setQrCode = (value: string) => (qrCode.value = value)
		const setColor = (value: string) => (color.value = value)
		const setLane = (value: string) => (lane.value = value)

		const $reset = () => {
			qrCode.value = ""
			color.value = ""
			lane.value = ""
		}

		return {
			qrCode,
			setQrCode,
			color,
			setColor,
			lane,
			setLane,
			$reset,
		}
	},
	{
		persist: {
			key: "up_qrInfoStore", // Make sure this key is unique
			storage: localStorage, // or cookies if you're using cookie storage
		},
	},
)
